<template>
  <div class="home">

    <!-- Mainview Area Start -->
    <div class="mainview">
      <img src="../assets/images/Mainview@2x.png" alt="My Photo">
    </div>


    <!-- Contents Area Start -->
    <div class="contents">

      <h2>John Milliam</h2>

      <h3>Hi I'm a <span class="type-it"></span></h3>

      <div class="sns-group">
        <a href="#"><i class="xi-facebook xi-3x"></i></a> 
        <a href="#"><i class="xi-twitter xi-3x"></i></a> 
        <a href="#"><i class="xi-youtube-play xi-3x"></i></a> 
        <a href="#"><i class="xi-google-plus xi-3x"></i></a> 
        <a href="#"><i class="xi-linkedin xi-3x"></i></a>
      </div>

      <p><a href="#">DOWNLOAD CV</a></p>

    </div>


    <!-- Footer Area Start -->
    <AppFooter></AppFooter>

  </div>
</template>

<script>
import AppFooter from './component/Footer.vue'

export default {
  name: "Home",
  components: {
    AppFooter
  },
  mounted() {
    this.typeEffect();
    this.menuAct1();
  },
  methods: {

    typeEffect(){
      $('.type-it').typeIt({
        strings: ['WEB DESIGNER!', 'WEB PUBLISHER!'],
        loop: true,
        breakLines: false,
        cursor: false,
        speed: 100 
      });
    },

    menuAct1(){
      $('.footer a').removeClass('menu-act');
      $('.footer li:nth-child(1) a').addClass('menu-act');
    }

  }
}
</script>

<style lang="scss" scoped>
@import '../sass/partials/_variable.scss', '../sass/partials/_mixin.scss';

  .home{
    padding: 0 !important;
    
    // Mainview Area Start
    .mainview img{ width: 100%; }


    // Contents Area Start
    .contents{     
      text-align: center;

      h2{
        height: 35px;
        color: $typo2;
        margin-bottom: 15px;
        @include font-set(500, 3rem, 35px, $ff4);
      }

      h3{
        height: 24px;
        color: $typo2;
        margin-bottom: 50px;
        @include font-set(400, 1.8rem, 24px, $ff5);
      }

      .sns-group{
        height: auto;
        margin-bottom: 30px;

        a{
          display: inline-block;
          width: 50px;
          height: 50px;
          line-height: 65px;
          color: $typo4;
          border: 1px solid $color2;
          border-radius: 50%;
          margin: 0 5px;

          &:hover{ color: $typo1; }
        }
      }

      p a{
        font-family: $ff1;
        font-weight: bold;
        border: 1px solid $typo2;
        @include btn-radius(220px, 50px, $bg-color3, $radius: true);
        &:hover{ background-color: $bg-color4; }
      }

    }

  }

</style>


// WEBPACK FOOTER //
// src/components/Home.vue